module.exports = __webpack_public_path__ + "assets/img/farm_monitor.f69a58c6.png";